module.exports = {"610330100":"双石铺镇","610330101":"凤州镇","610330102":"黄牛铺镇","610330103":"红花铺镇","610330104":"河口镇","610330105":"唐藏镇","610330106":"平木镇","610330107":"坪坎镇","610330110":"留凤关镇","610330400":"马头滩林业局","610330401":"辛家山林业场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610330.json
// module id = 2941
// module chunks = 0